import {HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpStatusCode} from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  BehaviorSubject,
  Subject,
  throwError,
  catchError,
  switchMap,
  tap,
  Observable,
  Subscription,
  EMPTY,
  timer, finalize
} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AUTH_KEYS} from '../services/auth-constants';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';

// Выносим общее состояние за пределы интерсептора
const accessTokenError$ = new BehaviorSubject<boolean>(false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const http = inject(HttpClient);
  const auth = inject(AuthService)
  const router = inject(Router);


  return next(req).pipe(
    catchError(err => {


      if(err.error.status === 403 && req.url.includes('me')){
        auth.CLearSession();
        router.navigate(['/auth']);
        return  EMPTY;
      }

      if (err.error.message === 'Invalid token' && req.url.includes('refresh') && !req.url.includes('reset-password')) {
        auth.CLearSession();
        //console.log('err.error.message');
        router.navigate(['/auth']);
        return  EMPTY;
      }

      if ((err.error.message === 'Invalid token' || err.error.message === 'Bad authorization') && !req.url.includes('refresh') && !req.url.includes('reset-password')) {
        return handleTokenRefresh(err, req, http, next,auth,router);
      }

      return throwError(() => err);
    })
  );
};

const handleTokenRefresh = (err: any, req: HttpRequest<any>, http: HttpClient, next: HttpHandlerFn,auth:any,router:any) => {
  if (!accessTokenError$.value) {
    accessTokenError$.next(true);


    //localStorage.removeItem(AUTH_KEYS.ACCESS_TOKEN);
    const url = environment.apiUrl + '/user/refresh';
    return http.post(url,{}).pipe(
      tap((event: any) => {
        console.log("tap")
        localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, event[AUTH_KEYS.ACCESS_TOKEN]);
        localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN,  event[AUTH_KEYS.REFRESH_TOKEN]);
        accessTokenError$.next(false);
      }),
      switchMap(() => {

        const newRequest = req.clone({
          setHeaders: {
            Authorization: `${localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN)}`
          }
        });
        return next(newRequest);
      }),
      catchError(er => {
        auth.CLearSession();
        console.log("accessTokenError$")
        router.navigate(['/auth']);
        return EMPTY;
      })
    );
  } else {
    return waitNewTokens().pipe(
      switchMap(() => {
        const newRequest = req.clone({
          setHeaders: {
            Authorization: `${localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN)}`
          }
        });
        return next(newRequest);
      }),
      catchError((er) => {
        auth.CLearSession();
        console.log("waitNewTokens")
        router.navigate(['/auth']);
        return EMPTY;
      })
    );

  }
};

const waitNewTokens = (): Observable<any> => {
  const subject = new Subject<any>();

  // Основная подписка на обновление токена
  const waitToken$: Subscription = accessTokenError$.subscribe(error => {
    if (!error) {
      subject.next(true);
      subject.complete(); // Важно завершить Subject
      waitToken$.unsubscribe();
    }
  });

  // Тайм-аут для предотвращения "зависания"
  const timeout$ = timer(10000).subscribe(() => {
    console.warn('Token refresh timeout exceeded');
    subject.error(new Error('Token refresh timeout'));
    subject.complete();
    waitToken$.unsubscribe();
    timeout$.unsubscribe();
  });

  // Обеспечиваем очистку ресурсов при отписке
  return subject.asObservable().pipe(
    finalize(() => {
      waitToken$.unsubscribe();
      timeout$.unsubscribe();
    })
  );
};
